import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { EmailInvite } from '../EmailInvite';
import { SocialLinks, User } from '../../../lib/interfaces';
import { ShareLink } from '../ShareLink';
import { innerClass } from './styles.ve.css';

interface InvitationProps {
  socialLinks: SocialLinks;
  inviteLink?: string;
  user?: User;
}
export const Invitation = ({ socialLinks, inviteLink, user }: InvitationProps) => (
  <Container
    as="main"
    display="flex"
    justifyContent="center"
    position="relative"
    paddingY={{ sm: '0' }}
    paddingX={{ sm: '8' }}
  >
    <Container className={innerClass}>
      <EmailInvite user={user} />
      <ShareLink inviteLink={inviteLink} socialLinks={socialLinks} />
    </Container>
  </Container>
);
